import { render, staticRenderFns } from "./marketplace.component.vue?vue&type=template&id=61236fb4&scoped=true"
import script from "./marketplace.component.vue?vue&type=script&lang=js"
export * from "./marketplace.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace.component.vue?vue&type=style&index=0&id=61236fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61236fb4",
  null
  
)

export default component.exports